import React from 'react';

interface CodeBlockProps {
  children: React.ReactNode;
  className?: string;
  preClassName?: string;
}

/**
 * Componente simplificado para renderizar blocos de código
 * Apenas o código, sem header ou botão copiar
 */
export const CodeBlock: React.FC<CodeBlockProps> = ({
  children,
  className,
  preClassName,
}) => {
  return (
    <pre className={preClassName || 'hljs'}>
      <code className={className}>{children}</code>
    </pre>
  );
};
